import { Component, OnInit, ViewChild, Input, Output, EventEmitter, AfterViewInit, OnChanges, SimpleChanges, ElementRef } from '@angular/core';
import { FlightStatusEnum } from 'solar-bo';;


@Component({
    selector: "app-flight-status",
    template: `<i [ngClass]="class" matTooltip="{{tooltip}}"></i> {{statusName}}`
})
export class FlightStatusIconComponent implements OnInit, OnChanges {
    @Input() status: string;
    statusName: string="";
    @Input() showStatusName: boolean=true;
    @Output() statusChange: EventEmitter<any> = new EventEmitter();
    tooltip = "";
    class: string = "status status-error fas fa-exclamation-circle";

    constructor() { }

    ngOnInit() {
        //this.setClassByStatus(+this.status);
    }

    ngOnChanges() {
        this.setClassByStatus(this.status);

    }

    setClassByStatus(st:string) {
        let newClass = "";
        let withpointer = "";


        if (st==FlightStatusEnum.FLIGHT_CREATED) {
            newClass = withpointer + " status status-open fas fa-lock-open";
            this.tooltip = "Flight is ready to add files process. ";
            this.statusName="Open";
        } else if (st === FlightStatusEnum.FLIGHT_LOADING_FILES) {
            newClass = "status status-warning fas fa-cogs";
            this.tooltip = "Flight is loading data and can not be modified. ";
            this.statusName="Loading";
        } else if (st === FlightStatusEnum.FLIGHT_FILE_PROCESS_PENDING) {
            newClass = "status status-warning fas fa-cogs";
            this.tooltip = "Loading finished. Flight is ready to process data. ";    
            this.statusName="Loading finished";        
        } else if (st === FlightStatusEnum.FLIGHT_FILE_PROCESSING) {
            newClass = "status status-warning fas fa-cogs";
            this.tooltip = "Flight is procesing data and can not be modified. ";
            this.statusName="Processing files";
        } else if (st === FlightStatusEnum.FLIGHT_ISSUES_PROCESS_PENDING) {
            newClass = withpointer + " status status-open fas fa-search";
            this.tooltip = "Processing files finished. Flight is ready to find issues. ";
            this.statusName="Processing finished";
        } else if (st === FlightStatusEnum.FLIGHT_ISSUES_PROCESSING) {
            newClass = withpointer + " status status-open fas fa-search";
            this.tooltip = "Searching issues. ";
            this.statusName="Searching";            
        } else if (st === FlightStatusEnum.FLIGHT_READY) {
            newClass = withpointer + " status status-closed fas fa-search";
            this.tooltip = "Searching issues finished";
            this.statusName="Searching finished";   
        } else if (st === FlightStatusEnum.FLIGHT_FILE_PROCESSING_ERROR) {
            newClass = withpointer + " status status-closed fas fa-lock";
            this.tooltip = "Flight data or files have errors";
            this.statusName="Error";  
        } else if (st === FlightStatusEnum.FLIGHT_LOADING_FILES_ERROR) {
            newClass = withpointer + " status status-closed fas fa-lock";
            this.tooltip = "Errors occurred while uploading data."; 
            this.statusName="Error";
        } else if (st === FlightStatusEnum.FLIGHT_ISSUES_PROCESSING_ERROR) {
            newClass = withpointer + " status status-closed fas fa-lock";
            this.tooltip = "Errors occurred while processing the data.";   
            this.statusName="Error";                     
        } else {
            newClass = withpointer + " status status-error fas fa-exclamation-circle";
            this.tooltip = "This flight has an unknown status";
            this.statusName="Unknown";
        }

        if (!this.showStatusName){
            this.statusName="";
        }
        this.class = newClass;
    }

    statusChangeHandler(status) {
        this.status = status;
        this.setClassByStatus(this.status);
    }


}

